import { apiSlice } from "./ApiSlice";

const AdddoctorApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    Adddoctor: builder.mutation({
      query: (credentials) => {
      
        return {
          url: "/api/ClinicProfile/DoctorDetails",
          method: "POST",
          body: credentials,
        };
      },
    }),

    PostFilteredDoctors: builder.mutation({
      query: (data) => ({
        url: `/api/ClinicProfile/DoctorsTableFilter`,
        method: "POST",
        body: data,
      }),
    }),

GetAllDocDashboard: builder.query({
  query: ({ doctorUserUniqueID, clinicId, startDate, endDate }) => ({
    url: `api/DoctorProfile/DoctorDashboardData?doctorUserUniqueID=${doctorUserUniqueID}&userClinicID=${clinicId}&startDate=${startDate}&endDate=${endDate}`,
    method: "GET",
  }),
   ProvidesTags: ["Prescription"],
}),



    Getalldocappointments: builder.query({
      query: ({ clinicUserId, doctorUserUniqueID }) => {
        return {
          url: `/api/ClinicProfile/GetAppointmentsByDoctor?userClinicID=${clinicUserId}&DoctorUserUniqueID=${doctorUserUniqueID}`,
          method: "GET"
        };
      },
    }),

    GetAppointmentDetailsById: builder.query({
      query: ({ appointmentId, userClinicId }) => ({
        url: `/api/ClinicProfile/GetAppointmentDetailsIndividualPatient?appointmentId=${appointmentId}&userClinicId=${userClinicId}`,
        method: "GET",
      }),
    }),

    Getalldoctors: builder.query({
      query: (clinicUserId) => {
        
        return {
          url: `/api/ClinicProfile/GetDoctorListView?userclinicid=${clinicUserId}`,
          method: "GET"
        };
      },
      providesTags: ["Doctors"],
    }),

    Getavailabledoctors: builder.query({
      query: ({ clinicUserId, selectedDate }) => {
        return {
          url: `/api/ClinicProfile/AvailableDoctorcards?userClinicID=${clinicUserId}&selectedDate=${selectedDate}`,
          method: "GET",
        };
      },
      providesTags: ["Doctors"],
    }),

    Getdoctor: builder.query({
      query: (doctorId) => {
      
        return {
          url: `/api/ClinicProfile/GetDoctorDetails?useruniqueid=${doctorId}`,
          method: "GET"
        };
      },
    }),

    Getprofile: builder.query({
      query: (uniqueUserId) => {
      
        return {
          url: `/api/ClinicProfile/GetDoctorDetails?useruniqueid=${uniqueUserId}`,
          method: "GET"
        };
      },
    }),

    Getdoctorview: builder.query({
      query: (doctorId) => {
      
        return {
          url: `/api/ClinicProfile/GetDoctorDetails?useruniqueid=${doctorId}`,
          method: "GET"
        };
      },
    }),

    InviteDoc: builder.mutation({
            query: credentials => {
              
                return {
                    url: '/api/Account/Invite',
                    method: 'POST',
                    body: credentials,
                }
            }
        }),

        addDoctor: builder.mutation({
            query: formData => ({
                 url: "/api/ClinicProfile/DoctorDetails",
                    method: 'POST',
                    body: formData,
            }),
            invalidatesTags: ['Doctors']
        }),

        getDoctor: builder.query({
            query: doctorId => ({
                url: `/api/ClinicProfile/GetDoctorDetails?useruniqueid=${doctorId}`,
                method: 'GET',
            })
        }),

        deactivateDoctor: builder.mutation({
            query: formData => ({
                url: `/api/ClinicProfile/DeactivateDoctor`,
                method: 'POST',
                body: formData
            }),
            invalidatesTags: ['Doctors']
        }),
        activateDoctor: builder.mutation({
            query: formData => ({
                url: `/api/ClinicProfile/ActivateDoctor`,
                method: 'POST',
                body: formData
            }),
            invalidatesTags: ['Doctors']
        }),

  }),
});

export const { useAdddoctorMutation, usePostFilteredDoctorsMutation, useGetAllDocDashboardQuery, useLazyGetalldocappointmentsQuery, useLazyGetAppointmentDetailsByIdQuery,useLazyGetalldoctorsQuery,useLazyGetavailabledoctorsQuery,useLazyGetdoctorQuery,useLazyGetprofileQuery,useLazyGetdoctorviewQuery,useInviteDocMutation,useAddDoctorMutation, useGetDoctorQuery, useLazyGetDoctorQuery, useDeactivateDoctorMutation, useActivateDoctorMutation } = AdddoctorApiSlice;
